import { Flex, Layout } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { useEffect, type ReactNode } from 'react';
import { useAppDispatch } from '../app/app.store';
import { setTheme } from '../app/features/auth/auth.slice';
import { APP_NAME } from '../config/global.config';
import useAuth from '../hooks/useAuth';
import Navbar from './_components/Navbar';
import Sidebar from './_components/Sidebar';

type Props = {
  children: ReactNode;
  title: string;
};

const DashboardLayout = ({ children, title }: Props) => {
  const { theme } = useAuth();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setTheme('dark'));
  }, [dispatch]);

  useEffect(() => {
    const html = document.documentElement;
    if (theme === 'dark') {
      html.classList.add('dark');
    } else {
      html.classList.remove('dark');
    }
  }, [theme]);

  useEffect(() => {
    document.title = `${title} | ${APP_NAME}`;
  }, [title]);
  return (
    <Layout className="min-h-screen custom-sidebar">
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content */}
      <Layout>
        {/* Navbar */}
        <Navbar />

        <Flex>
          {/* Body Content */}
          <Content className="p-6 pt-0 h-[calc(100vh_-_180px)] md:h-[calc(100vh_-_100px)] overflow-x-hidden overflow-y-auto">
            {children}
          </Content>
        </Flex>
      </Layout>
    </Layout>
  );
};

export default DashboardLayout;
